/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dropdrawcomplete2Inputs */

const en_dropdrawcomplete2 = /** @type {(inputs: Dropdrawcomplete2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Draw complete - now send the winner message`)
};

const de_dropdrawcomplete2 = /** @type {(inputs: Dropdrawcomplete2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ziehung abgeschlossen – jetzt Gewinner-Nachricht senden`)
};

/**
* | output |
* | --- |
* | "Draw complete - now send the winner message" |
*
* @param {Dropdrawcomplete2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const dropdrawcomplete2 = /** @type {((inputs?: Dropdrawcomplete2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dropdrawcomplete2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dropdrawcomplete2(inputs)
	return de_dropdrawcomplete2(inputs)
});
export { dropdrawcomplete2 as "dropDrawComplete" }